// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Date__pc_only___o-PDu","sp_only":"Date__sp_only___3VQwz","date":"Date__date___3c6f8"};